import { ArrowRight, Smartphone } from "lucide-react";

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.querySelector("#contatto");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      data-testid="hero-section"
      id="home"
      className="flex items-center pt-28 pb-16 md:pt-32 md:pb-20 bg-white"
    >
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-slate-100 text-slate-700 px-4 py-2 rounded-full text-sm font-medium mb-6 animate-fade-in">
            <Smartphone className="w-4 h-4 text-green-700" />
            100% Mobile-friendly
          </div>

          {/* Main Content */}
          <div className="animate-fade-in animation-delay-100">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-6 font-['Sora']">
              Siti web belli, veloci e che si fanno trovare.
            </h1>
            <p className="text-lg sm:text-xl text-slate-700 leading-relaxed mb-8 max-w-2xl mx-auto">
              Siamo un programmatore e un designer. Creiamo siti web per aziende 
              e professionisti che vogliono farsi notare online — senza spendere 
              una fortuna.
            </p>
          </div>

          {/* Single CTA */}
          <div className="animate-fade-in animation-delay-200">
            <button
              data-testid="hero-cta-primary"
              data-umami-event="richiedi-preventivo"
              data-umami-event-sezione="hero"
              onClick={scrollToContact}
              className="btn-primary inline-flex items-center gap-2 text-lg px-8 py-4"
            >
              Parlaci del tuo progetto
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
